import React from 'react';
import classes from './sixYardBreif.module.css';
import Title from "../../containers/title/title";

const SixYardBreif = ({introduction}) => {
    return (
        <div className={classes.Container}>
            <Title title={introduction?.title} />
            <div className={classes.Description}>
                <p>{introduction?.description}</p>
            </div>
        </div>
    )
}
export default SixYardBreif;